
let stepElementTitle = document.querySelectorAll(".step-element-title")

// For each button, register an event listener
stepElementTitle.forEach(function(elem){

  elem.addEventListener("click", function(e){

    if(/Android|webOS|iPhone|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && e.target.parentElement.parentElement.classList.contains("active")){
      e.target.closest('.step-element').classList.toggle("active");
    } else {
      // Add the class on clicked one
      // On click, remove the MyClass on ALL buttons
      stepElementTitle.forEach(function(el){
        el.closest('.step-element').classList.remove("active");
      });
      e.target.closest('.step-element').classList.add("active");
    }
  })
})


if(!/Android|webOS|iPhone|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  let linksTitleItems = document.querySelectorAll(".link-titles-item")

  // For each button, register an event listener
  linksTitleItems.forEach(function(elem){

    elem.addEventListener("click", function(e){

        // Add the class on clicked one
        // On click, remove the MyClass on ALL buttons
      linksTitleItems.forEach(function(el){
        el.classList.remove("active");
      });
      e.target.classList.add("active");
    })
  })
}
